<template>
    <div>
        <AppSection background-color="white" top-padding="large" bottom-padding="large">
            <Container type="row">
                <Container :lg="6">
                    <TeamSummary :team="team" />
                </Container>
                <Container :lg="6"></Container>
            </Container>
        </AppSection>
        <AppSection background-color="grey" top-padding="large" bottom-padding="large">
            <Container type="row">
                <Container>
                    <TeamSharing :team="team" :socialTitle="socialTitle" :socialDescription="socialDescription" />
                </Container>
            </Container>
        </AppSection>
        <AppSection v-if="game" background-color="white" top-padding="medium" bottom-padding="medium">
            <Container type="row">
                <Container>
                    <TeamRank
                        :game="game"
                        :limit="14"
                        background-color="white"
                        has-shadow="no-shadow"
                        grid-layout="span-1"
                        has-columns
                        title="De tussenstand"
                        paragraph="Welk team wordt de beste ambassadeur van de loterij? Dit zijn op dit moment de veertien best verkopende teams. Gaat jouw team de strijd aan?"
                    />
                </Container>
            </Container>
        </AppSection>
    </div>
</template>

<script>
import './team-page.scss';
import AppSection from '../global/AppSection';
import Container from '../global/Container';
import TeamSummary from './TeamSummary';
import TeamSharing from './TeamSharing';
import TeamRank from './TeamRank';

export default {
    name: 'TeamPage',
    components: { AppSection, Container, TeamSummary, TeamSharing, TeamRank },
    __editor: {
        requiredData: ['game'],
        fields: {
            socialTitle: {
                widget: 'text',
            },
            socialDescription: {
                widget: 'textarea',
            },
        },
    },
    props: {
        game: {
            type: Object,
        },
        socialTitle: {
            type: String,
            default: 'Doe mee met de Amateurvoetbal loterij!',
        },
        socialDescription: {
            type: String,
            default:
                'Voor maar € 2,50 per lot doe je al mee met de Amateurvoetbal loterij, waarmee je kans maakt op te gekke prijzen.',
        },
    },
    data() {
        return {
            team: {},
        };
    },
    computed: {
        affiliateId() {
            return this.$route.query.affiliate_id;
        },
    },
    created() {
        this.$api
            ?.getAffiliate(this.affiliateId)
            ?.then(affiliate => {
                if (!affiliate) {
                    this.error = true;
                } else {
                    this.team = { ...affiliate, id: this.affiliateId };
                }
            })
            ?.catch(() => {
                this.error = true;
            });
    },
    methods: {},
};
</script>
